<template>
  <div class="action">
    <input class="prefix" v-model="action.prefix" />
    <input class="action-item" v-model="action.action" />
    <input class="suggest" v-model="action.suggest" />
  </div>
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'Action',
  props: ['action'],
  components: {}
})
class Action extends Vue {
  @Prop action
}

export default Action
</script>

<style scoped lang="less">
.action {
  display: flex;
  flex-direction: row;
  align-items: stretch;

    .prefix {
        width: 5em;
    }
  .action-item, .suggest {
      flex-grow: 1
  }
}
</style>
